import { Theme, css } from '@emotion/react';

export const contentCardAccentuate = ({ colors }: Theme) => css`
  border-top: 4px solid ${colors.primary};
`;

export const contentCardHeader = ({ colors }: Theme) => css`
  align-items: center;
  border-bottom: 1px solid ${colors.borderLight};
  display: flex;
`;

export const contentCardHeaderTitle = css`
  flex: 1;
`;

export const contentCardContentCardMainFullBleed = css`
  padding: 0;
  &:last-child {
    padding-bottom: 0;
  }
`;
